module.exports = __webpack_public_path__ + "img/heart.c5d18b4b.png";